import icons from "../imgs/icons";

const wrapper = {
  width: "100%",
  height: "auto",
  margin: "0 auto",
  backgroundColor: "#000000",
  padding: "30px 0 20px 0",
  position: "fixed",
  left: 0,
  bottom: 0,
  overflow: "hidden",
  zIndex: 9,
  "& section": {
    paddingRight: "10%",
    position: "relative"
  },
  "& p, & a": {
    fontSize: "12px",
    fontFamily: "JWSansBook",
    lineHeight: "16px",
    letterSpacing: "0.45px",
    color: "#ffffff",
    textDecoration: "none",
    margin: 0
  },
  "& p": {
    marginBottom: "20px"
  },
  "& button": {
    position: "absolute",
    top: 0,
    right: "15px",
    background: `url(${icons.closeIconThin}) no-repeat`,
    border: "none",
    width: "18px",
    height: "18px",
    backgroundSize: "100% 100%",
    cursor: "pointer"
  },
  "& a": {
    textDecoration: "underline", 
  }
};

export default { wrapper };



// WEBPACK FOOTER //
// ./src/styles/cookie.js